<script setup>
import TvSection from '~/components/tv/TvSection.vue';
import TvJoinCode from '~/components/tv/TvJoinCode.vue';
import {TV_PANEL_ICON} from '~/utils/tvDisplay';

// One panel in the feature area, as a section card, laid out for the room it
// has. The mode (wide, column or portrait) reaches the panel by injection.
const props = defineProps({
  panel: {type: Object, required: true},
  mode: {type: String, default: 'wide'},
  page: {type: Number, default: 0},
  pages: {type: Number, default: 1},
  fill: {type: Boolean, default: false},
  component: {type: [Object, Function], required: true},
  componentProps: {type: Object, default: () => ({})},
});

provide('tvMode', computed(() => props.mode));
</script>

<template>
  <tv-section
      :icon="TV_PANEL_ICON[panel.kind]"
      :title="panel.title"
      :subtitle="mode === 'wide' ? panel.subtitle : panel.subtitle?.split(' · ')[0]"
      :sport="mode === 'wide' ? panel.sportName : null"
      :page="page"
      :pages="pages"
      :fill="fill"
      :class="{'tv-narrow': mode !== 'wide'}"
  >
    <component :is="component" v-bind="componentProps"/>
    <template v-if="panel.join" #footer>
      <tv-join-code :code="panel.join" :title="`Scan to join ${panel.title}`" :size="112"/>
    </template>
  </tv-section>
</template>
